import React from 'react';
import PoliglotLink from '../PoliglotLink';
import Title from '../Title';

import './index.css';
import Icon from '../Icon';
import styled from 'styled-components';
import { flexColumn, breakpoints, flexRow } from '../../../constants/styles';

const StyledCTACardContainer = styled.div`
  ${flexColumn}
  ${breakpoints.tablet} {
    width: 50%;
    justify-content: center;
    align-items: center;
  }
`;

export default function CTACard({
  showRightArrow,
  teaser,
  title,
  leftPoliglotLink,
  rightPoliglotLink,
  color,
}) {
  return (
    <StyledCTACardContainer>
      <Title level={3} className="teaser">
        {teaser}
      </Title>
      <div className="card" style={{ backgroundColor: color }}>
        <div className="header">
          <Title level={4} color="white" className="card-title">
            {title}
          </Title>
        </div>
        <div className="cta-section">
          <div className="left-button">
            <PoliglotLink
              link={leftPoliglotLink.link}
              blank={leftPoliglotLink.blank}
              className="left-link"
              text={leftPoliglotLink.text}
              local={leftPoliglotLink.local}
            />
          </div>
          <div className="mid-division"></div>
          <div className="right-button">
            <PoliglotLink
              link={rightPoliglotLink.link}
              blank={rightPoliglotLink.blank}
              className="right-link"
              text={rightPoliglotLink.text}
              local={rightPoliglotLink.local}
            >
              {showRightArrow && (
                <Icon size={20} icon="arrowForward" color="white" style={{ marginLeft: '10px' }} />
              )}
            </PoliglotLink>
          </div>
        </div>
      </div>
    </StyledCTACardContainer>
  );
}
